// extracted by mini-css-extract-plugin
export default {"main_wrapper":"styles_main_wrapper__9Q2If","wrapper":"styles_wrapper__F7H35","input":"styles_input__UoURz"};